module.exports = __webpack_public_path__ + "img/Logo.91cde42.svg";